/**
 * img要素をBase64に変換する
 */
export default class ImgElementToBase64 {
  /**
   * 変換
   *
   * @param img img要素
   * @param mimeType 変換するmimeType
   */
  public static convert(img: any, mimeType: string): string {
    let encodedImage: any = "";

    const canvas: HTMLCanvasElement = document.createElement("canvas");
    canvas.width = img.width;
    canvas.height = img.height;
    const context: CanvasRenderingContext2D | null = canvas.getContext("2d");
    if (context) {
      context.drawImage(img, 0, 0);
      encodedImage = canvas.toDataURL(mimeType);
    }

    return encodedImage;
  }
}
